import styled, { css } from 'styled-components';

export const ResponseWrapper = styled.div<{ firstResponse?: boolean }>(
    ({ firstResponse }) => css`
        margin-top: ${firstResponse ? 24 : 4}px;
    `,
);
